import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    PeopleAlt,
    EmojiEmotions,
    TipsAndUpdates,
    AccessTime,
    Favorite,
    DoneAll,
    Lightbulb,
    Star,
    Group,
    ArrowForwardIos,
    CheckCircle,
    Chat,
    PsychologyAlt
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    導入：ルームシェアの魅力と可能性
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('voice')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    長期ルームシェア経験者たちのリアルな声
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    ルームシェアを続けるコツ＆トラブル解決術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('friendship')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    友情が生まれる瞬間：エピソード集
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('lifeview')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    人生観への影響と新しい価値観
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('ideal')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    理想的な関係の築き方と未来へのヒント
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    導入：ルームシェアの魅力と可能性
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    ルームシェアは今や、単なる住まいの選択肢を超えた“生き方”のひとつです。
                    異なる背景や価値観を持つ人々が一つ屋根の下で暮らすことで、
                    日常の中に新しい発見や学び、そしてかけがえのない友情が生まれます。
                    この記事では、長期ルームシェア経験者へのインタビューを通じて、
                    「続けるコツ」「友情エピソード」「人生観への影響」「理想的な関係の築き方」など、
                    実践的な知恵や心温まるストーリーをご紹介します。
                    これからルームシェアを始める方や、今まさに暮らしている方にも役立つ内容を、
                    専門的な視点とリアルな声でお届けします。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={7}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#fafafa' }}>
                            <Typography variant="body2" sx={{ color: 'primary.main', mb: 1, fontWeight: 700 }}>
                                この記事でわかること
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <Star color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="長期ルームシェア経験者たちのリアルな体験談" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Lightbulb color="warning" />
                                    </ListItemIcon>
                                    <ListItemText primary="無理なく続けるためのヒントとトラブル解決法" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Favorite color="secondary" />
                                    </ListItemIcon>
                                    <ListItemText primary="友情・人間関係が育まれる瞬間のエピソード" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <PsychologyAlt color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="人生観や価値観への影響、そして未来へのヒント" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ p: 1 }}>

                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 長期ルームシェア経験者たちのリアルな声 */}
            <Box id="voice" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    長期ルームシェア経験者たちのリアルな声
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    実際に長期間ルームシェアを経験した複数の方に、日々の暮らしで感じたことや成長できた点、思い出深い瞬間について聞きました。
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <PeopleAlt color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>恵美さん（30代・会社員）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「最初は“他人と暮らすのは大変そう”と心配でしたが、気づけばお互いの趣味や悩みを語り合える大切な友人ができました。
                                    洗濯やゴミ出しの当番を決めるなど、小さなルールを作ることでストレスも少なく快適に暮らせています。」
                                </Typography>
                                <List dense sx={{ pl: 1 }}>
                                    <ListItem sx={{ p: 0 }}>
                                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                                        <ListItemText primary="生活リズムの違いも互いに尊重" />
                                    </ListItem>
                                    <ListItem sx={{ p: 0 }}>
                                        <ListItemIcon><Chat color="primary" /></ListItemIcon>
                                        <ListItemText primary="困った時は率直に話し合う" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Group color="secondary" sx={{ mr: 1 }} />
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>翔太さん（20代・デザイナー）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「一人暮らしでは得られなかった“誰かと過ごす安心感”がルームシェアにはありました。
                                    お互いの違いを認め合い、時には一緒にプロジェクトを始めることも。シェアでできた仲間が今の仕事のパートナーにもなっています。」
                                </Typography>
                                <List dense sx={{ pl: 1 }}>
                                    <ListItem sx={{ p: 0 }}>
                                        <ListItemIcon><DoneAll color="primary" /></ListItemIcon>
                                        <ListItemText primary="一緒に新しい挑戦ができる" />
                                    </ListItem>
                                    <ListItem sx={{ p: 0 }}>
                                        <ListItemIcon><EmojiEmotions color="secondary" /></ListItemIcon>
                                        <ListItemText primary="支え合うことで自信もアップ" />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, mb: 2 }}>
                    <img
                        src="/images/blog/share-experience-talk_roomshare-friendship-success-interview.jpg"
                        alt="夜の落ち着いた共有スペースで、2人のルームメイトがソファに座ってリラックスしながら、笑顔で語り合う様子。暖色系の間接照明と観葉植物が居心地の良さと親密な雰囲気を強調している。"
                        style={{ width: '100%', borderRadius: 12 }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    他にも「多国籍メンバーの料理パーティー」「深夜の人生相談」「一緒に趣味を始めて人生が広がった」など、シェア生活ならではの貴重な体験談がたくさん寄せられています。
                </Typography>
            </Box>

            {/* 続けるコツ＆トラブル解決術 */}
            <Box id="tips" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアを続けるコツ＆トラブル解決術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    長期で快適なルームシェアを続けるには、ちょっとしたコツと“お互い様”の気持ちが大切です。経験者が実践してきた工夫や、ありがちなトラブルを円満に解決する方法をご紹介します。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#f6fafd', borderRadius: 2, mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', fontWeight: 600 }}>
                        続けるための5つのポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <TipsAndUpdates color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="コミュニケーションはマメに"
                                secondary="小さなことでも気になったらすぐに話し合う。週1回のハウスミーティングでストレスを溜めない工夫を。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <AccessTime color="info" />
                            </ListItemIcon>
                            <ListItemText
                                primary="生活リズム・プライバシーの尊重"
                                secondary="お互いの生活時間や静かにしたい時間を共有しておくことで無理なく続けやすく。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="ルールや分担を明確に"
                                secondary="掃除やゴミ出し、共有スペースの使い方など、ルールを可視化しておくとトラブル予防に。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <EmojiEmotions color="secondary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="感謝や気遣いを言葉で伝える"
                                secondary="「ありがとう」「ごめんね」を積極的に。ちょっとした一言が信頼関係を強くします。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Lightbulb color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="問題が起きたら第三者の意見も活用"
                                secondary="当事者同士で解決が難しい時は、シェアハウスの管理人や外部サポートを頼るのも手。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Box sx={{ mb: 2 }}>

                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    ちょっとした「ありがとう」の積み重ねが、長い共同生活を円満に保つ秘訣です。
                </Typography>
            </Box>

            {/* 友情が生まれる瞬間：エピソード集 */}
            <Box id="friendship" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    友情が生まれる瞬間：エピソード集
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    ルームシェア最大の魅力、それは「予想もできない友情」と「人生を変える出会い」です。
                    実際にあった心温まるエピソードをいくつかご紹介します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Favorite color="secondary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    思いがけないサプライズ誕生日
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「仕事で落ち込んでいた時、ルームメイトがみんなでケーキを用意してサプライズ誕生日パーティーをしてくれたんです。<br />
                                “ここが帰る場所なんだ”と実感できた瞬間でした。」
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Group color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    夜のリビングでの人生相談
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「就職活動に悩んでいたとき、夜遅くまでリビングで話を聞いてくれたルームメイト。<br />
                                “一人じゃない”と心から思えました。」
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Star color="warning" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    一緒に始めた趣味が人生を変える
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「ルームメイトの影響で朝ランニングを始めました。<br />
                                今では一緒にマラソン大会にも挑戦する仲に。体も心も一回り成長できました。」
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <EmojiEmotions color="success" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    価値観の違いが絆に
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「ルームシェア相手の友人たちと多国籍メンバーで世界の料理を持ち寄る“国際パーティー”を開催！<br />
                                異文化交流を通じて、視野も友人も大きく広がりました。」
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 3, mb: 2 }}>
                    <img
                        src="/images/blog/friendship-dinner-party_roomshare-friendship-success-interview.jpg"
                        alt="モダンなダイニングで多様なルームメイトたちが笑顔で食卓を囲み、手作り料理を楽しみながら賑やかに語り合う様子。温かい照明とカラフルな料理が、絆や多様性、家庭的な雰囲気を象徴している。"
                        style={{ width: '100%', borderRadius: 12 }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    こうした日々の“小さな感動”が、シェアライフを特別なものにしています。
                </Typography>
            </Box>

            {/* 人生観への影響と新しい価値観 */}
            <Box id="lifeview" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    人生観への影響と新しい価値観
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    ルームシェアは“他者と生きる”ことをリアルに体験できる場。
                    共同生活を通じて「自分らしさ」「多様性」「思いやり」など、多くのことを学んだという声が目立ちます。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8fafd', borderRadius: 2, mb: 3 }}>
                    <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', fontWeight: 600 }}>
                        シェア生活で得られる新しい価値観
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <PsychologyAlt color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="多様性の受容力がアップ"
                                secondary="異なる価値観・文化・習慣を尊重できるようになる"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="自分の小さな殻を破る経験"
                                secondary="思いもよらない挑戦や成長のきっかけが増える"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Favorite color="secondary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="本質的な人間関係の大切さ"
                                secondary="物や立場よりも“信頼”と“思いやり”が最も大切だと気づく"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Lightbulb color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="柔軟な考え方と解決力"
                                secondary="予想外の出来事にも前向きに向き合えるようになる"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    ルームシェアで得た経験は、仕事や人生のあらゆる場面で“生きる力”として活かされていきます。
                </Typography>
            </Box>

            {/* 理想的な関係の築き方と未来へのヒント */}
            <Box id="ideal" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    理想的な関係の築き方と未来へのヒント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 3 }}>
                    ルームシェアの成功は、相手や自分を“支配”するのではなく、互いの違いを“楽しむ”ことから始まります。
                    継続的に良好な関係を築くためのアドバイスや、これからルームシェアを始める方へのヒントをまとめます。
                </Typography>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#f6fafd', borderRadius: 2, mb: 3 }}>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <TipsAndUpdates color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="スタート時にしっかり自己開示を"
                                secondary="自分の希望や苦手なことを最初に伝えておくことで、ミスマッチや誤解を防げます。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <EmojiEmotions color="secondary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="ほどよい距離感を大切に"
                                secondary="無理に仲良くなろうとせず、適度な距離を保つことで長続きしやすくなります。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="warning" />
                            </ListItemIcon>
                            <ListItemText
                                primary="“違い”を楽しむマインドを持つ"
                                secondary="価値観やライフスタイルの違いは、新しい発見や成長のきっかけ。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Lightbulb color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="困ったときは早めに相談"
                                secondary="問題がこじれる前に、一言声をかける勇気を持ちましょう。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    ルームシェアは「住まい」以上の価値をもたらします。新しい自分や人との出会いを楽しみながら、一歩踏み出してみてはいかがでしょうか。
                </Typography>
            </Box>

            {/* 記事下部：タグとまとめ */}
            <Divider sx={{ my: 3 }} />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 2, gap: 1 }}>
                <Chip label="ルームシェア" color="primary" variant="outlined" />
                <Chip label="友情" color="secondary" variant="outlined" />
                <Chip label="共同生活" color="success" variant="outlined" />
                <Chip label="人間関係" color="info" variant="outlined" />
                <Chip label="成功体験" color="warning" variant="outlined" />
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                この記事が、あなたのルームシェアライフに少しでも役立つヒントや勇気を与えられれば幸いです。
            </Typography>
        </Box>
    );
};

const post = {
    id: 'roomshare-friendship-success-interview',
    slug: 'roomshare-friendship-success-interview',
    title: 'ルームシェアから生まれた友情と成功体験：長期シェア経験者インタビュー',
    excerpt: '長期シェア経験者の声 続けるコツ 友情エピソード 人生観への影響 理想的な関係の築き方',
    coverImage: '/images/blog/cover-share-house-friendship_roomshare-friendship-success-interview.jpg',
    coverImageAlt:
        '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。カラフルなクッションや木目調のテーブル、観葉植物などが温かみと安心感を演出し、共同生活の魅力と人と人との絆を象徴している。',
    publishedAt: '2024-06-11T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', 'ライフスタイル', '人間関係'],
    tags: ['ルームシェア', '友情', '共同生活', '人生観', '成功体験'],
    author: {
        name: 'Yuki Sato',
        avatar: '/images/avatars/yuki-sato.jpg',
        bio: 'ルームシェア・共同生活アドバイザー。さまざまなシェアハウス運営や入居サポートを経験し、実体験に基づくアドバイスや成功事例を多数発信。人と人のつながりや、快適なシェアライフのコツを伝えることに力を入れている。',
        profilePicture: '/images/avatars/yuki-sato.jpg'
    },
    viewCount: 1278,
    contentComponent: PostContent
};

export default post;